<template>
  <div class="d-inline-flex">
    <!-- visible badges -->
    <EntityBadge
      v-for="(entity, index) in visibleEntities"
      :key="`v-${index}`"
      :entity="entity"
      class="mr-1"
    >
    </EntityBadge>

    <!-- more... -->
    <b-button
      v-if="hiddenEntities.length"
      ref="more"
      variant="outline-secondary"
      size="sm"
      class="cursor-pointer align-self-start"
      v-b-tooltip.hover
      :title="hiddenEntities.map(e => e.name).join(', ')"
      @click="showModal = true"
    >
      +{{ hiddenEntities.length }} more...
    </b-button>

    <!-- modal fallback (optional) -->
    <b-modal v-model="showModal" title="All Items" hide-footer>
      <EntityBadge
        v-for="(entity, index) in entities"
        :key="`v-${index}`"
        :entity="entity"
        class="mr-1 mb-1"
      >
      </EntityBadge>
    </b-modal>
  </div>
</template>

<script>
import EntityBadge from '@/xvisor/components/custom/EntityBadge.vue';
import useBreakpoint from '@/xvisor/components/custom/useBreakpoint';

export default {
  components: {
    EntityBadge,
  },
  mixins: [useBreakpoint],
  props: {
    entities: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  computed: {
    visibleEntities() {
      return this.entities.slice(0, this.nShow);
    },
    hiddenEntities() {
      return this.entities.slice(this.nShow, this.entities.length);
    },
    nShow() {
      return this.isWide ? 4 : 2;
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
